interface RandomizeState {
  lastPlayer: number | null;
  consecutivePlays: number;
  lastDoublePlayTime: number;
  truePlayerSwitches: number;  // Track number of true player switches
  requireTrueSwitches: boolean;
}

export const useRandomize = (playerCount: number, validPlayers?: number[]) => {
  const getRandomPlayer = (state: RandomizeState): number => {
    const { lastPlayer, truePlayerSwitches } = state;
    const availablePlayers = validPlayers || Array.from({ length: playerCount }, (_, i) => i + 1);
    
    if (availablePlayers.length === 0) return 1; // Fallback
    
    // If we haven't had 5 true switches yet, force a different player
    if (truePlayerSwitches < 5) {
      let newPlayer;
      const otherPlayers = availablePlayers.filter(p => p !== lastPlayer);
      if (otherPlayers.length > 0) {
        newPlayer = otherPlayers[Math.floor(Math.random() * otherPlayers.length)];
      } else {
        newPlayer = availablePlayers[Math.floor(Math.random() * availablePlayers.length)];
      }
      return newPlayer;
    }

    // After 5 true switches, allow any random selection but with weighted probability
    // 90% chance to pick a different track, 10% chance to allow same track
    const shouldForceDifferent = Math.random() < 0.9;
    
    if (shouldForceDifferent) {
      const otherPlayers = availablePlayers.filter(p => p !== lastPlayer);
      if (otherPlayers.length > 0) {
        return otherPlayers[Math.floor(Math.random() * otherPlayers.length)];
      }
    }
    
    return availablePlayers[Math.floor(Math.random() * availablePlayers.length)];
  };

  return { getRandomPlayer };
}; 